import {useEffect, useRef} from 'react'
import {useDispatch} from 'react-redux'

import {trackEvent} from '@vio/core/src/analytics/modules/actions'
import {Action, Category, Entity} from '@vio/core/src/analytics/types/Events'

/**
 * Fire-once tracking for preferred rate offer render.
 * Dispatches a `System_PreferredRateOffer_Served` event.
 */
export const useTrackPreferredRateOfferServed = (isYourChoice: boolean) => {
  const dispatch = useDispatch()
  const hasFired = useRef(false)

  useEffect(() => {
    if (hasFired.current || !isYourChoice) return

    hasFired.current = true

    dispatch(
      trackEvent({
        category: Category.System,
        entity: Entity.PreferredRateOffer,
        action: Action.Served
      })
    )
  }, [isYourChoice, dispatch])
}
